import { TextInput } from '@mantine/core';
import _ from 'lodash';
import { useEffect, useMemo, useState } from 'react';

import { searchIcon } from '@assets';
import { SEARCH_DEBOUNCE_DELAY } from '@constants';
import classes from './SearchBox.module.css';

interface SearchBoxProps {
  handleSearch?: (value: string) => void;
  placeholder?: string;
  value?: string;
  disabled?: boolean;
  'data-pw'?: string;
}

export const SearchBox: React.FC<SearchBoxProps> = (props) => {
  const { value: intialValue, handleSearch, placeholder, disabled } = props;
  const [value, setValue] = useState(intialValue || '');

  const executeSearch = useMemo(
    () =>
      _.debounce((searchQuery: string) => {
        handleSearch(searchQuery);
      }, SEARCH_DEBOUNCE_DELAY),
    [handleSearch],
  );

  useEffect(() => {
    return () => {
      executeSearch.cancel();
    };
  }, []);

  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    executeSearch(e.target.value);
  };

  return (
    <TextInput
      classNames={{
        root: classes.container,
        input: classes.input,
      }}
      value={value}
      onChange={handleValueChange}
      placeholder={placeholder}
      leftSection={<img src={searchIcon} alt="search" />}
      data-pw={props['data-pw']}
      disabled={disabled}
    />
  );
};
